import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { NotificationsModel } from '../models/Notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(private http: HttpClient) { }

  GetUnseenNotificationCount() {
    return this.http.get(`${environment.apiUrl}/Notification/GetUnseenNotificationCount`);
  }
  GetNotifications(data: NotificationsModel) {
    return this.http.post(`${environment.apiUrl}/Notification/Notifications`, data);
  }
  UpdateNotificationsSeenStatus() {
    return this.http.get(`${environment.apiUrl}/Notification/UpdateNotificationsSeenStatus`);
  }
}
